import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-duoxuankuang",
  "use": "icon-duoxuankuang-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-duoxuankuang\"><path d=\"M832 928l-640 0c-52.92544 0-96-43.06944-96-96l0-640c0-52.92544 43.07456-96 96-96l640 0c52.93056 0 96 43.07456 96 96l0 640C928 884.93056 884.93056 928 832 928zM192 160c-17.63328 0-32 14.36672-32 32l0 640c0 17.664 14.36672 32 32 32l640 0c17.664 0 32-14.336 32-32l0-640c0-17.63328-14.336-32-32-32L192 160z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol